const zhCN = {
  deviceTypesTxt: '设备类型',
  option_allDeviceType: '全部设备',
  alarmTypeTxt: '报警类型',
  option_allAlarmType: '全部报警',

  startTimeTxt: '开始时间',
  endTimeTxt: '结束时间',
  aWeekBeforeBtn: '前一周',
  oneMonthBeforeBtn: '前一个月',
  threeMonthsBeforeBtn: '前三个月',

  deviceSNOrNameTxt: '设备SN/设备名称',
  searchBtn: '搜索',

  listAlarmType: '报警类型',
  listDeviceSN: '设备SN',
  listDeviceName: '设备名称',
  listAlarmTime: '报警时间',
  listAlarmDiscribe: '报警描述',

  getRecordsFail: '获取报警记录失败！',

  sitePhotoModalTitle: '现场照片'
}
const enUS = {
  deviceTypesTxt: 'Device Type',
  option_allDeviceType: 'All Device Type',
  alarmTypeTxt: 'Alarm Type',
  option_allAlarmType: 'All Alarm Type',
  
  startTimeTxt: 'Start Time',
  endTimeTxt: 'End Time',
  aWeekBeforeBtn: 'a week before',
  oneMonthBeforeBtn: 'one month before',
  threeMonthsBeforeBtn: 'three months before',
  
  deviceSNOrNameTxt: 'Device SN / Name',
  searchBtn: 'Search',

  listAlarmType: 'Alarm Type',
  listDeviceSN: 'Device SN',
  listDeviceName: 'Device Name',
  listAlarmTime: 'Alarm Time',
  listAlarmDiscribe: 'Alarm Discribe',

  getRecordsFail: 'Get alarm records failed!',

  sitePhotoModalTitle: 'Site Photo'
}

export default { zhCN, enUS }